import { Shield, Globe, Heart, CheckCircle, Lock } from "lucide-react";

const badges = [
  { icon: Lock, label: "Secure Payments" },
  { icon: Shield, label: "GDPR Compliant" },
  { icon: Globe, label: "5 Countries" },
  { icon: Heart, label: "500+ Families" },
  { icon: CheckCircle, label: "Verified Caregivers" },
];

const TrustBadges = () => {
  return (
    <section className="bg-muted/40 border-y border-border/50 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
          {badges.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex items-center gap-2 text-muted-foreground"
            >
              <Icon className="w-4 h-4 text-primary/70" aria-hidden="true" />
              <span className="text-sm font-medium">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
